import { Input as InputAntd } from 'antd';
import styled from 'styled-components';
import { remConvert } from 'src/theme/utils';

export const TextAreaStyled = styled(InputAntd.TextArea)`
  background: ${({ theme }): string => theme.colors.white.main};
  border: ${remConvert(1)} solid rgba(0, 0, 0, 0.3);
  border-radius: ${remConvert(4)};
`;
